document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.tabs-wrapper').forEach((wrapper) => {
    const buttons = wrapper.querySelectorAll('.tab-button');
    const panes = wrapper.querySelectorAll('.tab-pane');

    function activateTab(id) {
      buttons.forEach((btn) => btn.classList.toggle('active', btn.dataset.tab === id));
      panes.forEach((pane) => pane.classList.toggle('active', pane.id === id));
    }

    // Default to first tab
    if (buttons.length > 0) {
      activateTab(buttons[0].dataset.tab);
    }

    buttons.forEach((btn) => {
      btn.addEventListener('click', () => {
        activateTab(btn.dataset.tab);
      });
    });
  });
});
